export const PageTitle = ({ title = '' }: { title: string }) => {
  return (
    <h2 className="text-[29px] md:text-[45px] font-bold tracking-tight mb-4 md:mb-8 text-center">
      {title}
    </h2>
  );
};
